export default __webpack_public_path__ + "static/media/flag-full-1.3fb9dd37.svg";